"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketingCarousel = void 0;
const React = require("react");
const react_1 = require("react");
const react_responsive_carousel_1 = require("react-responsive-carousel");
require("react-responsive-carousel/lib/styles/carousel.min.css"); // requires a loader
const ErrorPlaceholder_1 = require("../../../../../components/base/structure/ErrorPlaceholder");
const PendingContentBlock_1 = require("../../../../../components/base/structure/PendingContentBlock");
const dialogs_1 = require("../../../../../types/dialogs");
const Modal_1 = require("../../../../../components/base/structure/Modal");
const Button_1 = require("../../../../../components/base/atoms/Button");
const MarketingContext_1 = require("../../contexts/MarketingContext");
const openLink_1 = require("../../../../../helpers/openLink");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "MarketingCarousel");
const MarketingCarousel = ({}) => {
    const { retrieveMarketingItems, isRetrievingMarketingItems, retrieveMarketingItemsError } = (0, react_1.useContext)(MarketingContext_1.MarketingContext);
    const [marketingItems, setMarketingItems] = (0, react_1.useState)(null);
    const [currentMarketingItem, setCurrentMarketingItem] = (0, react_1.useState)(null);
    const retrieveMarketingContent = async () => {
        const mItems = await retrieveMarketingItems();
        setMarketingItems(mItems);
    };
    (0, react_1.useEffect)(() => {
        retrieveMarketingContent().catch(console.error);
    }, []);
    return (React.createElement("div", { className: css("") },
        retrieveMarketingItemsError && (React.createElement(ErrorPlaceholder_1.default, { title: "Could not retrieve marketing content", retry: retrieveMarketingContent })),
        isRetrievingMarketingItems && (React.createElement(PendingContentBlock_1.PendingContentBlock, { check: false, size: "full" })),
        Array.isArray(marketingItems) && marketingItems.length > 0 && (React.createElement("div", { className: css("container") },
            React.createElement("div", { className: css("carousel") },
                React.createElement(react_responsive_carousel_1.Carousel, { animationHandler: "slide", showStatus: false, showArrows: true, showIndicators: true, showThumbs: false, infiniteLoop: true, centerMode: marketingItems.length > 1, centerSlidePercentage: 80, useKeyboardArrows: false, autoPlay: true, stopOnHover: true, swipeable: true, dynamicHeight: true, emulateTouch: true, interval: 10000, transitionTime: 2000, swipeScrollTolerance: 5, onClickItem: (index) => {
                        const marketingItem = marketingItems[index];
                        if (marketingItem.infoUrl) {
                            setCurrentMarketingItem(marketingItem);
                        }
                    } }, marketingItems.map((marketingItem) => (React.createElement("div", { key: marketingItem.slug, className: css("image"), style: {
                        backgroundImage: `url("${marketingItem.bannerUrl}")`,
                        margin: `0 ${marketingItems.length > 1 ? "4px" : "0"}`
                    } }))))))),
        React.createElement(Modal_1.Modal, { open: !!currentMarketingItem, onClose: () => setCurrentMarketingItem(null), size: dialogs_1.TDialogSizes.Medium, showCloseIcon: true, appMode: true },
            React.createElement(Modal_1.ModalHeader, null, "Visit external site?"),
            React.createElement(Modal_1.ModalBody, null, "Clicking continue will take you to an external site. Do you wish to proceed?"),
            React.createElement(Modal_1.ModalFooter, null,
                React.createElement(Button_1.BlockButton, { onClick: () => (0, openLink_1.openLink)(currentMarketingItem.infoUrl) }, "Continue")))));
};
exports.MarketingCarousel = MarketingCarousel;
//# sourceMappingURL=index.js.map